const ChevronDown = () => {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00009 4.3654L12.3601 0.732405C12.7841 0.378405 13.4151 0.436405 13.7681 0.860405C14.1221 1.28541 14.0641 1.9154 13.6401 2.2684L7.64009 7.2684C7.59309 7.3074 7.53809 7.3274 7.48609 7.3564C7.44409 7.3804 7.40809 7.4094 7.36209 7.4274C7.24709 7.4724 7.12609 7.4994 7.00409 7.4994C6.87409 7.4994 6.75309 7.4724 6.63809 7.4274C6.59209 7.4094 6.55609 7.3804 6.51409 7.3564C6.46209 7.3274 6.40709 7.3074 6.36009 7.2684L0.360091 2.2684C0.123091 2.07041 9.05991e-05 1.7864 9.05991e-05 1.5004C9.05991e-05 1.27441 0.0760908 1.0474 0.232091 0.860405C0.585091 0.436405 1.21609 0.378405 1.64009 0.732405L6.00009 4.3654L7.00409 5.3654" fill="currentColor" />
    </svg>
  );
};

export default ChevronDown;
